import _ from "lodash";
export const getIsCriterionSelected = _.memoize(
  ({ selectedCriteria, criterionId }) => {
    return (
      _.findIndex(
        selectedCriteria,
        selectedCriterionId => selectedCriterionId === criterionId
      ) > -1
    );
  },
  params => JSON.stringify(params)
);

export const getCheckboxState = _.memoize(
  ({ selectedCriteria, singleLevel, criteria, criterionId }) => {
    const checkboxState = { isIndeterminate: false, isChecked: false };
    if (singleLevel) {
      const isCriterionSelected = getIsCriterionSelected(criterionId);
      checkboxState.isChecked = isCriterionSelected;
    } else {
      const criterionNode = _.find(
        criteria,
        criterion => _.get(criterion, "id") === criterionId
      );

      const criterionNodeChildren = _.get(criterionNode, "children", []);

      if (!_.isEmpty(criterionNodeChildren)) {
        const isAllChildrenSelected = _.every(
          criterionNodeChildren,
          selectedCriterionId =>
            _.includes(selectedCriteria, selectedCriterionId)
        );

        const isSomeChildrenSelected = _.some(
          criterionNodeChildren,
          selectedCriterionId =>
            _.includes(selectedCriteria, selectedCriterionId)
        );

        if (isAllChildrenSelected) {
          checkboxState.isChecked = true;
        } else if (isSomeChildrenSelected) {
          checkboxState.isIndeterminate = true;
        }
      }
    }
    return checkboxState;
  },
  params => JSON.stringify(params)
);

export const getUpdatedCriteria = _.memoize(
  ({
    selectedCriteria,
    singleLevel,
    criteria,
    criterionId,
    isCriterionSelected,
  }) => {
    let addRemoveCriteria = [criterionId];

    if (!singleLevel) {
      // logic to handle multi level criteria
      const criterionNode = _.find(
        criteria,
        criterion => _.get(criterion, "id") === criterionId
      );
      const criterionNodeChildren = _.get(criterionNode, "children");
      const parentNodeId = _.get(criterionNode, "parent", null);

      // if selected criterion is a parent, then add select the children criteria too
      if (criterionNodeChildren) {
        addRemoveCriteria = [...addRemoveCriteria, ...criterionNodeChildren];
      } else if (parentNodeId) {
        if (isCriterionSelected) {
          const parentNode = _.find(
            criteria,
            criterion => _.get(criterion, "id") === parentNodeId
          );
          const parentNodeChildren = _.get(parentNode, "children", null);
          if (
            _.size(_.intersection(selectedCriteria, parentNodeChildren)) === 1
          ) {
            addRemoveCriteria = [...addRemoveCriteria, parentNodeId];
          }
        } else {
          // if parent is not in the selected list, add it as well
          if (
            !getIsCriterionSelected({
              selectedCriteria,
              criterionId: parentNodeId,
            })
          ) {
            addRemoveCriteria = [...addRemoveCriteria, parentNodeId];
          }
        }
      }
    }

    if (isCriterionSelected) {
      return _.filter(
        selectedCriteria,
        selectedCriterionId =>
          !_.includes(addRemoveCriteria, selectedCriterionId)
      );
    }
    return [...selectedCriteria, ...addRemoveCriteria];
  },
  params => JSON.stringify(params)
);

const _getSelectedAssessmentTool = ({
  assessmentTools,
  assessmentToolType,
}) => {
  return _.get(
    _.find(
      assessmentTools,
      tool => _.get(tool, "node.assessmentToolType", "") === assessmentToolType
    ),
    "node.assessmentToolItem",
    {}
  );
};

export const getSelectedAssessmentTool = _.memoize(
  _getSelectedAssessmentTool,
  params => JSON.stringify(params)
);

export const getIsDPRubricGlobal = _.memoize(
  ({ assessmentToolType, assessmentTools }) => {
    if (assessmentToolType !== "DP_ASSESSMENT_RUBRIC") {
      return false;
    }
    const dpRubric = _.find(
      assessmentTools,
      ({ node }) => node?.assessmentToolType === assessmentToolType
    );
    return _.get(dpRubric, "node.assessmentToolItem.isGlobal");
  },
  params => JSON.stringify(params)
);
